import { useState, useEffect, useCallback } from "react"
import { doc, getDoc, updateDoc } from "firebase/firestore"
import { db } from "../../services/firebase"
import { useAuth } from "../../context/AuthContext"

const TABLA_CANJE = [
  { puntos: 50,  descuento: 10  },
  { puntos: 100, descuento: 25  },
  { puntos: 350, descuento: 100 },
]

export function calcularTotalPuntos(p) {
  const suma =
    (p.puntos_aporte      || 0) +
    (p.puntos_feedback    || 0) +
    (p.puntos_referidos   || 0) +
    (p.puntos_compra_ref  || 0) +
    (p.puntos_cumpleanos  || 0)
  return suma - (p.puntos_usados || 0)
}

export function calcularDescuentoUSD(pts) {
  if (pts <= 0) return 0
  const n350 = Math.floor(pts / 350)
  const r1   = pts % 350
  const n100 = Math.floor(r1 / 100)
  const r2   = r1 % 100
  const n50  = Math.floor(r2 / 50)
  return n350 * 100 + n100 * 25 + n50 * 10
}

export default function CargarPuntos({ clienteId, clienteNombre }) {
  const { user }  = useAuth()
  const [puntos, setPuntos]       = useState(null)
  const [loading, setLoading]     = useState(true)
  const [guardando, setGuardando] = useState(false)
  const [exito, setExito]         = useState("")
  const [error, setError]         = useState("")

  const [feedback,     setFeedback]     = useState("")
  const [referidos,    setReferidos]    = useState("")
  const [compraRef,    setCompraRef]    = useState("")
  const [puntosUsados, setPuntosUsados] = useState("")
  const [motivoUso,    setMotivoUso]    = useState("")

  const cargar = useCallback(async () => {
    setLoading(true)
    try {
      const snap = await getDoc(doc(db, "usuarios_sheets", clienteId))
      if (snap.exists()) {
        const d = snap.data()
        setPuntos({
          puntos_aporte:     d.puntos_aporte     || 0,
          puntos_feedback:   d.puntos_feedback   || 0,
          puntos_referidos:  d.puntos_referidos  || 0,
          puntos_compra_ref: d.puntos_compra_ref || 0,
          puntos_cumpleanos: d.puntos_cumpleanos || 0,
          puntos_usados:     d.puntos_usados     || 0,
          cumple_anio:       d.cumple_anio       || null,
        })
      }
    } catch (e) { console.error(e) }
    finally { setLoading(false) }
  }, [clienteId])

  useEffect(() => { cargar() }, [cargar])

  async function guardar(campo, valor, label) {
    if (isNaN(valor) || valor < 0) return setError("Valor invalido.")
    setError("")
    setGuardando(true)
    try {
      await updateDoc(doc(db, "usuarios_sheets", clienteId), {
        [campo]: valor,
        ultimo_cambio_puntos: new Date(),
        cambio_por: user?.email,
      })
      setExito(label + " guardado correctamente.")
      setTimeout(() => setExito(""), 3000)
      await cargar()
    } catch (e) { setError("Error al guardar. Intenta de nuevo.") }
    finally { setGuardando(false) }
  }

  const input = {
    width: "100%", padding: "10px 14px", background: "#1a1a1a",
    border: "1px solid #3a3a3a", borderRadius: "8px", color: "#e5e7eb",
    fontFamily: "Inter, sans-serif", fontSize: "0.9rem", outline: "none"
  }

  const btn = (color) => ({
    padding: "10px 16px", background: color, border: "none", borderRadius: "8px",
    color: "white", fontFamily: "Inter, sans-serif", fontWeight: 700,
    cursor: "pointer", whiteSpace: "nowrap"
  })

  const card = (borderColor) => ({
    background: "#0f0f0f",
    border: "1px solid " + (borderColor || "#2a2a2a"),
    borderRadius: "12px", padding: "20px"
  })

  if (loading) return <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>Cargando puntos...</div>
  if (!puntos) return <div style={{ padding: "40px", textAlign: "center", color: "#ef4444" }}>No se encontro el cliente.</div>

  const total      = calcularTotalPuntos(puntos)
  const mejorCanje = [...TABLA_CANJE].reverse().find(t => total >= t.puntos)

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

      {/* TOTAL */}
      <div style={card()}>
        <div style={{ fontSize: "0.75rem", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>
          Total de puntos — {clienteNombre}
        </div>
        <div style={{ fontSize: "2.4rem", fontWeight: 800, color: total >= 0 ? "#f59e0b" : "#ef4444", lineHeight: 1 }}>
          {total} pts
        </div>
        {mejorCanje && (
          <div style={{ marginTop: "8px", fontSize: "0.8rem", color: "#10b981", fontWeight: 600 }}>
            Puede canjear hasta -{mejorCanje.descuento} USD
          </div>
        )}
        {!mejorCanje && total > 0 && (
          <div style={{ marginTop: "8px", fontSize: "0.8rem", color: "#6b7280" }}>
            Necesita {50 - total} pts mas para el primer canje (-10 USD)
          </div>
        )}
      </div>

      {/* DESGLOSE */}
      <div style={{ background: "#0f0f0f", border: "1px solid #2a2a2a", borderRadius: "12px", overflow: "hidden" }}>
        <div style={{ padding: "14px 20px", borderBottom: "1px solid #2a2a2a", fontWeight: 700, color: "#e5e7eb", fontSize: "0.9rem" }}>
          Desglose de puntos
        </div>
        {[
          { label: "Por viajes (10% del aporte)",  valor: puntos.puntos_aporte,     color: "#3b82f6", icono: "✈️" },
          { label: "Por cumpleanos",                valor: puntos.puntos_cumpleanos, color: "#f59e0b", icono: "🎂" },
          { label: "Por feedback",                  valor: puntos.puntos_feedback,   color: "#8b5cf6", icono: "💬" },
          { label: "Por referidos (max 3)",         valor: puntos.puntos_referidos,  color: "#10b981", icono: "👥" },
          { label: "Por compra de referidos",       valor: puntos.puntos_compra_ref, color: "#06b6d4", icono: "🤝" },
          { label: "Puntos canjeados",              valor: puntos.puntos_usados,     color: "#ef4444", icono: "💸", resta: true },
        ].map(item => (
          <div key={item.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px", borderBottom: "1px solid #1a1a1a" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>{item.icono}</span>
              <span style={{ fontSize: "0.875rem", color: "#9ca3af" }}>{item.label}</span>
            </div>
            <span style={{ fontWeight: 700, color: item.color, fontSize: "0.95rem" }}>
              {item.resta ? "-" : "+"}{item.valor} pts
            </span>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", background: "#141414" }}>
          <span style={{ fontWeight: 700, color: "#e5e7eb" }}>TOTAL</span>
          <span style={{ fontWeight: 800, fontSize: "1.1rem", color: total >= 0 ? "#f59e0b" : "#ef4444" }}>
            {total} pts
          </span>
        </div>
      </div>

      {/* TABLA CANJE */}
      <div style={{ background: "#0f0f0f", border: "1px solid #2a2a2a", borderRadius: "12px", overflow: "hidden" }}>
        <div style={{ padding: "14px 20px", borderBottom: "1px solid #2a2a2a", fontWeight: 700, color: "#e5e7eb", fontSize: "0.9rem" }}>
          Tabla de canje disponible
        </div>
        {TABLA_CANJE.map(t => {
          const disponible = total >= t.puntos
          return (
            <div key={t.puntos} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px", borderBottom: "1px solid #1a1a1a", opacity: disponible ? 1 : 0.4 }}>
              <span style={{ fontSize: "0.875rem", color: "#9ca3af" }}>{t.puntos} puntos</span>
              <span style={{ fontWeight: 700, color: disponible ? "#10b981" : "#6b7280" }}>
                {disponible ? "✓" : "✗"} -{t.descuento} USD
              </span>
            </div>
          )
        })}
      </div>

      {/* FEEDBACK */}
      <div style={card()}>
        <div style={{ fontWeight: 700, color: "#8b5cf6", marginBottom: "12px", fontSize: "0.9rem" }}>
          Puntos por feedback — Actual: {puntos.puntos_feedback} pts
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <input type="number" min="0" placeholder="Nuevo total" value={feedback} onChange={e => setFeedback(e.target.value)} style={{ ...input, flex: 1 }} />
          <button onClick={() => { guardar("puntos_feedback", Number(feedback), "Feedback"); setFeedback("") }} disabled={guardando || !feedback} style={btn("#8b5cf6")}>
            Guardar
          </button>
        </div>
      </div>

      {/* REFERIDOS */}
      <div style={card()}>
        <div style={{ fontWeight: 700, color: "#10b981", marginBottom: "4px", fontSize: "0.9rem" }}>
          Puntos por referidos — Actual: {puntos.puntos_referidos} pts
        </div>
        <div style={{ fontSize: "0.8rem", color: "#6b7280", marginBottom: "12px" }}>
          +30 pts por referido, max 3 referidos (90 pts)
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <input type="number" min="0" max="90" placeholder="Total acumulado (30 / 60 / 90)" value={referidos} onChange={e => setReferidos(e.target.value)} style={{ ...input, flex: 1 }} />
          <button onClick={() => { guardar("puntos_referidos", Math.min(Number(referidos), 90), "Referidos"); setReferidos("") }} disabled={guardando || !referidos} style={btn("#10b981")}>
            Guardar
          </button>
        </div>
      </div>

      {/* COMPRA REFERIDO */}
      <div style={card()}>
        <div style={{ fontWeight: 700, color: "#06b6d4", marginBottom: "4px", fontSize: "0.9rem" }}>
          Puntos por compra de referidos — Actual: {puntos.puntos_compra_ref} pts
        </div>
        <div style={{ fontSize: "0.8rem", color: "#6b7280", marginBottom: "12px" }}>
          +50 pts cada vez que un referido viaja
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <input type="number" min="0" placeholder="Nuevo total acumulado" value={compraRef} onChange={e => setCompraRef(e.target.value)} style={{ ...input, flex: 1 }} />
          <button onClick={() => { guardar("puntos_compra_ref", Number(compraRef), "Compra de referido"); setCompraRef("") }} disabled={guardando || !compraRef} style={btn("#06b6d4")}>
            Guardar
          </button>
        </div>
      </div>

      {/* CANJE */}
      <div style={card("#ef444430")}>
        <div style={{ fontWeight: 700, color: "#ef4444", marginBottom: "4px", fontSize: "0.9rem" }}>
          Registrar canje — Actual usados: {puntos.puntos_usados} pts
        </div>
        <div style={{ fontSize: "0.8rem", color: "#6b7280", marginBottom: "12px" }}>
          Ingresar el TOTAL acumulado de puntos canjeados hasta hoy
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <input type="number" min="0" placeholder="Total puntos usados" value={puntosUsados} onChange={e => setPuntosUsados(e.target.value)} style={input} />
          <input type="text" placeholder="Motivo (ej: Descuento viaje Cancun 2026)" value={motivoUso} onChange={e => setMotivoUso(e.target.value)} style={input} />
          <button onClick={() => { guardar("puntos_usados", Number(puntosUsados), "Canje"); setPuntosUsados(""); setMotivoUso("") }} disabled={guardando || !puntosUsados} style={btn("#ef4444")}>
            Registrar canje
          </button>
        </div>
      </div>

      {exito && <div style={{ padding: "12px 16px", background: "#0a2a1a", border: "1px solid #10b98140", borderRadius: "8px", color: "#10b981", fontWeight: 600 }}>{exito}</div>}
      {error && <div style={{ padding: "12px 16px", background: "#2a0a0a", border: "1px solid #ef444440", borderRadius: "8px", color: "#ef4444", fontWeight: 600 }}>{error}</div>}

    </div>
  )
}